import actionCreator from '../../createAction';

const createAction = actionCreator('groups');

export const GET_GROUP_MEMBERS = createAction('GET_GROUP_MEMBERS');
export const GET_GROUPS = createAction('GET_GROUPS');
export const GET_GROUP_DETAILS = createAction('GET_GROUP_DETAILS');
export const CREATE_GROUP = createAction('CREATE_GROUP');
export const UPDATE_GROUP = createAction('UPDATE_GROUP');
export const DELETE_GROUP = createAction('DELETE_GROUP');
export const RESTORE_GROUP = createAction('RESTORE_GROUP');
export const GET_GROUP_MEMBERS_COUNT = createAction('GET_GROUP_MEMBERS_COUNT');
export const GET_WORKFLOW_STEPS = createAction('GET_WORKFLOW_STEPS');
export const REMOVE_MEMBERS = createAction('REMOVE_MEMBERS');
export const DELETE_CAMPAIGN_STEP = createAction('DELETE_CAMPAIGN_STEP');
export const UPDATE_NEW_STEP = createAction('UPDATE_NEW_STEP');
export const RESET_NEW_STEP = createAction('RESET_NEW_STEP');
export const ADD_CONTACTS_TO_GROUP = createAction('ADD_CONTACTS_TO_GROUP');
export const UPDATE_CAMPAIGN_STEP = createAction('UPDATE_CAMPAIGN_STEP');
export const COPY_WORKFLOW_STEP = createAction('COPY_WORKFLOW_STEP');
export const CREATE_WORKFLOW_STEP = createAction('CREATE_WORKFLOW_STEP');
export const GET_SYNC_LOGS = createAction('GET_SYNC_LOGS');
